import React from 'react'


class EncrpytedInput extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeString = this.handleChangeString.bind(this)
        this.textInput = HTMLInputElement
        this.state = { 
            value: props.value
        }
    }

    handleChange(event) {

        let password
        let email
        let type




        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
        nativeInputValueSetter.call(this.textInput, password)


        this.setState({
            email: email,
            password: password,
            type: type
        })




    }

    handleChangeString(event) {

        this.props.onChange(event)
    }

    render() {
        //console.log(this.state.password)
        return (
            <div className="input-group">
                <input
                    type={this.props.type}
                    className="form-control"
                    onChange={this.handleChangeString}
                    id={this.props.id}
                    name={this.props.name}
                    ref={inp => { this.textInput = inp }}
                    placeholder={this.props.placeholder}
                />

            </div>
        )
    }
}

export default EncrpytedInput


// WEBPACK FOOTER //
// ./src/components/encryptedInput.js